import { fetchApi, fetchApiFile } from "./utils";

export const setTheme = async (pageID, themeClass, themeFontColor) =>
  fetchApi("/set-theme/global", {
    method: "POST",
    params: { pageID, themeClass, themeFontColor },
  });

export const setThemeDesign = async (
  pageID,
  themeColor,
  bbgc,
  btc,
  bbr,
  backgroundSetting,
  backgroundImage
) =>
  fetchApi("/set-theme/design", {
    method: "POST",
    params: {
      pageID,
      themeColor,
      bbgc,
      btc,
      bbr,
      backgroundSetting,
    },
  });

export const uploadBackgroundPictureToAWS = async (
  formData,
  pageID,
  oldImg
) => {
  let imageUrl = await fetchApiFile(
    `/set-theme/upload-background-image?pageID=${pageID}&oldImg=${oldImg}`,
    {
      method: "POST",
      params: formData,
    }
  );
  return imageUrl;
};
